import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../components/Button';
import { Check, X } from 'lucide-react';
export function DarkSections() {
  return <div className="bg-navy text-white" data-id="element-170">
      {/* RESULTADO */}
      <section className="py-24 border-b border-slate-800" data-id="element-171">
        <div className="container mx-auto px-4" data-id="element-172">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-173">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight leading-tight" data-id="element-174">
              Más información. Mejores decisiones.{' '}
              <span className="text-cyan" data-id="element-175">Más licitaciones rentables.</span>
            </h2>
          </motion.div>

          <div className="grid grid-cols-2 md:grid-cols-5 gap-6 max-w-6xl mx-auto" data-id="element-176">
            {[{
            value: '14k+',
            label: 'Riesgos detectados'
          }, {
            value: '2.5M',
            label: 'Documentos analizados'
          }, {
            value: '850k',
            label: 'Horas ahorradas'
          }, {
            value: '45k+',
            label: 'Consultas sugeridas'
          }, {
            value: '$1.2B',
            label: 'Potenciales impactos económicos'
          }].map((stat, i) => <motion.div key={i} initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-slate-900 border border-slate-800 rounded-xl p-6 text-center" data-id="element-177">
                <div className="text-3xl md:text-4xl font-bold text-cyan mb-2" data-id="element-178">
                  {stat.value}
                </div>
                <div className="text-xs font-medium text-slate-400 uppercase tracking-wider" data-id="element-179">
                  {stat.label}
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* VENTAJA COMPETITIVA */}
      <section className="py-24 relative overflow-hidden" data-id="element-180">
        {/* Background glow */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-techblue/10 blur-[120px] rounded-full pointer-events-none" data-id="element-181" />

        <div className="container mx-auto px-4 relative z-10" data-id="element-182">
          <div className="max-w-5xl mx-auto" data-id="element-183">
            <div className="grid md:grid-cols-2 gap-8" data-id="element-184">
              {/* Tradicional */}
              <motion.div initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} className="bg-slate-900/50 border border-slate-800 rounded-2xl p-8 opacity-80" data-id="element-185">
                <h3 className="text-xl font-semibold text-slate-400 mb-8 pb-4 border-b border-slate-800" data-id="element-186">
                  Método tradicional
                </h3>
                <ul className="space-y-6" data-id="element-187">
                  {['cientos de PDFs', 'revisión manual', 'tiempo limitado', 'riesgo invisible'].map((item, i) => <li key={i} className="flex items-center gap-4 text-slate-500" data-id="element-188">
                      <div className="w-6 h-6 rounded-full bg-slate-800 flex items-center justify-center shrink-0" data-id="element-189">
                        <X size={14} className="text-risk/70" data-id="element-190" />
                      </div>
                      <span className="text-lg" data-id="element-191">{item}</span>
                    </li>)}
                </ul>
              </motion.div>

              {/* Prisma */}
              <motion.div initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} className="bg-slate-800/40 border border-techblue/30 rounded-2xl p-8 relative shadow-[0_0_40px_-10px_rgba(37,99,235,0.2)]" data-id="element-192">
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-techblue to-cyan rounded-t-2xl" data-id="element-193" />
                <h3 className="text-xl font-bold text-white mb-8 pb-4 border-b border-slate-700 flex items-center gap-2" data-id="element-194">
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-techblue to-cyan" data-id="element-195">
                    Prisma
                  </span>
                </h3>
                <ul className="space-y-6" data-id="element-196">
                  {['análisis completo', 'riesgo visible', 'información conectada', 'inteligencia accionable'].map((item, i) => <motion.li key={i} initial={{
                  opacity: 0,
                  x: 10
                }} whileInView={{
                  opacity: 1,
                  x: 0
                }} viewport={{
                  once: true
                }} transition={{
                  delay: 0.2 + i * 0.1
                }} className="flex items-center gap-4 text-slate-200" data-id="element-197">
                      <div className="w-6 h-6 rounded-full bg-techblue/20 flex items-center justify-center shrink-0 border border-techblue/30" data-id="element-198">
                        <Check size={14} className="text-cyan" data-id="element-199" />
                      </div>
                      <span className="text-lg font-medium" data-id="element-200">{item}</span>
                    </motion.li>)}
                </ul>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section className="py-32 border-t border-slate-800 relative overflow-hidden" data-id="element-201">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#1e293b_1px,transparent_1px),linear-gradient(to_bottom,#1e293b_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)] opacity-20" data-id="element-202" />

        <div className="container mx-auto px-4 relative z-10 text-center max-w-4xl" data-id="element-203">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-204">
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight leading-tight mb-6" data-id="element-205">
              Antes de comprometer millones, entiende exactamente qué estás
              licitando.
            </h2>
            <p className="text-xl text-slate-400 mb-10" data-id="element-206">
              Descubre riesgos, oportunidades y requisitos ocultos antes de
              presentar tu oferta.
            </p>
            <Button size="lg" variant="solid" className="text-lg px-8 h-14" data-id="element-207">
              Solicitar Demo
            </Button>
          </motion.div>
        </div>
      </section>
    </div>;
}